import React, { useState, useEffect } from "react";
import { useWatchState, useModal, useDebounce, setState, handler } from "@/store";
import { checkResult, createSelectOption } from "@/common";
import { Upload } from "@/components";
import BraftEditor from "braft-editor";
import { BaseService, TYCService, uploadUrl } from "@/service";
import { economicCircle, companyScale } from "@/dic";
import moment from "moment";
import { Modal, Button, Form, Input, message, Select, Tag, Icon, Menu, Dropdown, Row, Col, Divider, Cascader } from "antd";

const { TextArea } = Input;
const TABLE_NAME = "thtt_xuqiu";
const NAME = "demand";

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 16,
            offset: 8,
        },
    },
};

const App = Form.create({ name: 'register' })(({ form }) => {

    const { getFieldDecorator } = form;

    const [loading, setLoading] = useState(false);

    const [scopeSelectModal] = useModal(["scopeSelect"])
    const [[{ user_id }]] = useWatchState(["user.info"])
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME])
    const { title = "发布需求", show, hide, width = 800, vo = { sub_type: 1 }, state, contrast, callback, scopes = [], files = {}, UPLOAD_SERVER_HOST } = modalProps;
    const [[REGIONS = []]] = useWatchState(["$_REGIONS"]);

    const [searchResult, setSearchResult] = useState([]);
    const [showSearchRes, setShowSearchRes] = useState(false);
    const [selectOrgVo, setSelectOrg] = useState();

    useEffect(() => {
        if (!show) {
            setSelectOrg();
        }
    }, [show])

    const onCloseScope = (index, e) => {
        // 组织 antd 默认事件，它会自动把当前点击标签后面的标签隐藏掉！还不知道为什么
        e.preventDefault();
        scopes.remove(index);
        setProps({ ...modalProps })
    }

    const onChangeOrgScope = scopes => {
        modalProps.scopes = scopes;
        setProps({ ...modalProps })
    }

    const orgHandle = async (vo) => {
        const add_time = parseInt(new Date().getTime() / 1000)

        let unit_id = "";
        let org = {};
        if (vo.org_name) org.name = vo.org_name;
        if (vo.org_profile) org.profile = vo.org_profile;
        if (vo.org_reg_location) org.reg_location = vo.org_reg_location;
        if (vo.org_social_credit_code) org.social_credit_code = vo.org_social_credit_code;
        if (vo.org_contacts) org.contacts = vo.org_contacts;
        if (vo.org_contacts_tel) org.contacts_tel = vo.org_contacts_tel;
        if (vo.org_contacts_email) org.contacts_email = vo.org_contacts_email;
        if (vo.org_wechat) org.wechat = vo.org_wechat;
        if (vo.org_economic_circle) org.economic_circle = vo.org_economic_circle;
        if (vo.org_staff_num_range) org.staff_num_range = vo.org_staff_num_range;
        if (vo.org_assets) org.assets = vo.org_assets;
        if (vo.org_capital) org.capital = vo.org_capital;
        if (vo.org_technology) org.technology = vo.org_technology;
        if (vo.org_business) org.business = vo.org_business;
        if (vo.org_provinceName) org.provinceName = vo.org_provinceName;
        if (vo.org_cityName) org.cityName = vo.org_cityName;
        if (vo.org_countyName) org.countyName = vo.org_countyName;
        if (vo.org_province) org.province = vo.org_province;
        if (vo.org_city) org.city = vo.org_city;
        if (vo.org_county) org.county = vo.org_county;

        // 保存机构信息
        if (selectOrgVo && selectOrgVo.name === vo.org_name) {
            org.estiblish_time = selectOrgVo.estiblishTime;
            org.legal_person_name = selectOrgVo.legalPersonName;
            org.tyc_org_id = selectOrgVo.id;
            org.tyc_type = selectOrgVo.companyType;
            org.social_credit_code = selectOrgVo.creditCode;
            org.organization_code = selectOrgVo.orgNumber;
            org.reg_number = selectOrgVo.regNumber;
            org.legal_type = selectOrgVo.type;
        }
        // 先查询是否已经存在
        let list = [];
        if (vo.org_name) {
            const getRes = await BaseService.list({
                table: "thtt_organization",
                where: {
                    name: vo.org_name,
                    is_delete: 0
                }
            })
            list = getRes.data.result;
        }

        // 修改
        if (list.length) {
            const organization_id = list[0].organization_id;
            unit_id = organization_id;
            await BaseService.put({
                table: "thtt_organization",
                data: org,
                where: { organization_id }
            })
        } else { // 新增
            const addRes = await BaseService.add({
                table: "thtt_organization",
                data: { ...org, is_delete: 0, add_time, audit_status: 4 },
                key: "organization_id"
            })
            if (!checkResult(addRes)) return setLoading(false);
            unit_id = addRes.data.result.organization_id;
        }

        return unit_id
    }

    const add = async vo => {
        const add_time = parseInt(new Date().getTime() / 1000)
        setLoading(true);

        const unit_id = await orgHandle(vo);

        try {
            const res = await BaseService.add({ table: TABLE_NAME, data: { ...vo, add_time, unit: unit_id, is_delete: 0, add_user: user_id, audit_status: 1, complete_time: new Date().format("yyyy-MM-dd hh:mm:ss") }, key: "xuqiu_id" });
            if (!checkResult(res)) return setLoading(false);
            const xuqiu_id = res.data.result.xuqiu_id;
            // 保存成果领域
            const scopeRes = await BaseService.adds({
                table: "thtt_xuqiu_scope",
                data: scopes.map(({ value, pid }) => ({ xuqiu_id, first_scope_id: pid, second_scope_id: value }))
            })
            let _files = []
            Object.values(files).forEach(arr => _files = _files.concat(arr));
            const addFileRes = await BaseService.adds({
                table: "thtt_attachment_relation",
                data: _files.map(val => ({ ...val, item_id: xuqiu_id }))
            })
            setLoading(false);
            if (!checkResult(scopeRes)) return;
            message.success("添加成功！");
            hide();
            if (callback) callback();
        } catch (error) {
            setLoading(false);
        }
    }

    const put = async values => {
        const update_time = moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        let vo = contrast(values, ["xuqiu_id", "org_name"]);
        setLoading(true);
        try {
            const unit_id = await orgHandle(vo);

            const res = await BaseService.put({ table: TABLE_NAME, data: { ...vo, update_time, unit: unit_id }, where: { xuqiu_id: vo.xuqiu_id } });
            if (!checkResult(res)) return setLoading(false);

            const works = [
                {
                    controller: "remove",
                    params: {
                        table: "thtt_xuqiu_scope",
                        where: {
                            xuqiu_id: vo.xuqiu_id
                        }
                    }
                },
                {
                    controller: "adds",
                    params: {
                        table: "thtt_xuqiu_scope",
                        data: scopes.map(({ value, pid }) => ({ xuqiu_id: vo.xuqiu_id, first_scope_id: pid, second_scope_id: value }))
                    }
                }
            ]
            const scopeRes = await BaseService.work(works)
            let _files = []
            Object.values(files).forEach(arr => _files = _files.concat(arr));
            const works2 = [
                {
                    controller: "remove",
                    params: {
                        table: "thtt_attachment_relation",
                        where: {
                            item_id: vo.xuqiu_id,
                            type: Object.keys(files)
                        }
                    }
                },
                {
                    controller: "adds",
                    params: {
                        table: "thtt_attachment_relation",
                        data: _files
                    }
                }
            ]
            const fileRes = await BaseService.work(works2)

            setLoading(false);
            message.success("修改成功！");
            hide();
            if (callback) callback();
        } catch (error) {
            setLoading(false);
            throw error
        }
    }

    const funs = { add, put }

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                const data = { ...vo, ...values };

                if (!scopes.length) return message.warn("请选择领域！");
                if (!data.org_province) return message.warn("请选择所属地区！")
                if (!data.profile) return message.warn("请录入需求简介！")

                if (data.profile) data.profile = data.profile.toHTML ? data.profile.toHTML() : data.old_profile;
                funs[state](data);
            }
        });
    };

    const onUploadFileFinish = (type, e) => {
        const size = e.file.size;
        const add_time = new Date().format("yyyy-MM-dd hh:mm:ss");
        const newFiles = e.file.response.files.map(({ fileShowName, suffix, url }) => ({ type, item_id: vo.xuqiu_id, file_name: fileShowName, file_path: url, file_suffix: suffix, size, add_time }));
        if (!modalProps.files) modalProps.files = {};
        if (!modalProps.files[type]) modalProps.files[type] = newFiles;
        else modalProps.files[type] = modalProps.files[type].concat(newFiles);
        setProps({ ...modalProps });
    }
    const onRemoveFile = (type, file) => {
        modalProps.files[type].remove(file.uid - 1);
        setProps({ ...modalProps });
    }

    // 选中搜索结果
    const selectOrg = org => {
        const { name } = org;
        setSelectOrg(org)
        form.setFieldsValue({
            org_name: name,
        });
        getAndRefreshOrg(name)
    }

    const getAndRefreshOrg = name => {
        BaseService.list({
            table: "thtt_organization",
            columns: ["organization_id", "name", "profile", "reg_location", "contacts", "contacts_tel", "contacts_email", "wechat", "economic_circle", "staff_num_range", "team_scale", "social_credit_code", "assets", "capital", "technology", "business", "province", "city", "county", "provinceName", "cityName", "countyName"].map(field => `${field} AS org_${field}`).join(","),
            where: { name, is_delete: 0 }
        }).then(res => {
            if (!checkResult(res)) return;
            const data = res.data.result;
            if (data.length) {
                const org = data[0];
                modalProps.vo.org_region_id = [vo.org_province, vo.org_city, vo.org_county];
                modalProps.vo = {
                    ...modalProps.vo,
                    ...org
                }
                form.setFieldsValue(org);
            }
        })
    }

    const getMenu = (data = []) => {
        return (
            <Menu className="search_result_list" style={{ height: "200px", overflow: "auto" }}>
                {data.map(org => (
                    <Menu.Item keys={org.name} onClick={selectOrg.later({ ...org, name: org.name.getBytesContent() })}><div dangerouslySetInnerHTML={{ __html: org.name }} /></Menu.Item>
                ))}
            </Menu>
        )
    }

    const onChnageOrgName = useDebounce(word => {
        TYCService.search({ word }).then(res => {
            if (!checkResult(res)) return;
            setSearchResult(res.data.result.records || res.data.result.items)
        }, err => {
            throw err;
        })
    }, 200)

    const onChangeProfile = e => {
        if (!modalProps.vo) modalProps.vo = { sub_type: 1 }
        modalProps.vo.profile = e;
        setProps({ ...modalProps });
    }

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
            destroyOnClose={true}
        >
            <Form onSubmit={handleSubmit}>
                <div className="over-auto" style={{ height: "65vh" }}>
                    <Divider orientation="left">基本信息</Divider>
                    <Form.Item label="单位名称">
                        <Dropdown overlay={getMenu(searchResult)} visible={searchResult.length && showSearchRes}>
                            {getFieldDecorator('org_name', {
                                initialValue: vo.org_name,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入单位名称！',
                                    },
                                ],
                            })(
                                <Input onChange={e => {
                                    const word = e.target.value;
                                    if (!word) {
                                        setSearchResult([]);
                                        return
                                    }
                                    if (word) onChnageOrgName(word)
                                }} onFocus={setShowSearchRes.later(true)} onBlur={() => setTimeout(() => setShowSearchRes(false), 100)} placeholder="请输入单位名称" autoComplete="off" />
                            )}
                        </Dropdown>
                    </Form.Item>
                    <Row gutter={18}>

                        <Col span={12}>
                            <Form.Item label="所属地区" required>
                                {getFieldDecorator('org_region_id', {
                                    getValueFromEvent: (v, o) => {
                                        const values = o.map(({ value }) => value)
                                        const names = o.map(({ label }) => label)

                                        vo.org_province = values[0];
                                        vo.org_city = values[1];
                                        vo.org_county = values[2];

                                        vo.org_provinceName = names[0];
                                        vo.org_cityName = names[1];
                                        vo.org_countyName = names[2];
                                        setState("modal." + NAME + ".vo", { ...vo });
                                        return v;
                                    }
                                })(
                                    <Cascader
                                        options={REGIONS}
                                        changeOnSelect
                                        loadData={handler.onLoadRegion}
                                        className={vo.org_provinceName && "mockInput"}
                                        placeholder={vo.org_provinceName && vo.org_provinceName.length ? [vo.org_provinceName, vo.org_cityName, vo.org_countyName].join(" / ") : '请选择地区！'} />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="社会统一信用代码">
                                {getFieldDecorator('org_social_credit_code', {
                                    initialValue: vo.org_social_credit_code,
                                })(<Input maxLength={50} placeholder="请输入通讯地址" />)}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label="通讯地址">
                        {getFieldDecorator('contacts_addr', {
                            initialValue: vo.contacts_addr,
                            rules: [
                                {
                                    required: true,
                                    message: '请输入通讯地址！',
                                },
                            ],
                        })(<Input maxLength={500} placeholder="请输入通讯地址" />)}
                    </Form.Item>
                    <Row gutter={18}>
                        <Col span={12}>
                            <Form.Item label="联系人">
                                {getFieldDecorator('contacts', {
                                    initialValue: vo.contacts,
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入联系人！',
                                        },
                                    ],
                                })(<Input maxLength={50} placeholder="请输入联系人" />)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="联系电话">
                                {getFieldDecorator('contacts_tel', {
                                    initialValue: vo.contacts_tel,
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入联系电话！',
                                        },
                                    ],
                                })(<Input maxLength={100} placeholder="请输入联系电话" />)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="E-mail">
                                {getFieldDecorator('contacts_email', {
                                    initialValue: vo.contacts_email,
                                })(<Input maxLength={200} placeholder="请输入E-mail" />)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="微信">
                                {getFieldDecorator('contacts_wechat', {
                                    initialValue: vo.contacts_wechat,
                                })(<Input maxLength={100} placeholder="请输入微信" />)}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="经济圈划定">
                                {getFieldDecorator('org_economic_circle', {
                                    initialValue: vo.org_economic_circle,
                                })(<Select placeholder="请选择经济圈划定">{createSelectOption(economicCircle)}</Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="单位规模">
                                {getFieldDecorator('org_staff_num_range', {
                                    initialValue: vo.org_staff_num_range,
                                })(<Select placeholder="请选择单位规模">{createSelectOption(companyScale)}</Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="资产">
                                {getFieldDecorator('org_assets', {
                                    initialValue: vo["org_assets"] || undefined
                                })(
                                    <Select placeholder="请选择资产">
                                        {createSelectOption([{ label: "国有", value: 1 }, { label: "民营", value: 2 }])}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="资本">
                                {getFieldDecorator('org_capital', {
                                    initialValue: vo["org_capital"] || undefined
                                })(
                                    <Select placeholder="请选择资本">
                                        {createSelectOption([{ label: "上市", value: 1 }, { label: "普通", value: 2 }])}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="科技">
                                {getFieldDecorator('org_technology', {
                                    initialValue: vo["org_technology"] || undefined
                                })(
                                    <Select placeholder="请选择科技">
                                        {createSelectOption([{ label: "高新", value: 1 }, { label: "传统", value: 2 }])}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="业务">
                                {getFieldDecorator('org_business', {
                                    initialValue: vo["org_business"] || undefined
                                })(
                                    <Select placeholder="请选择业务">
                                        {createSelectOption([{ label: "制造", value: 1 }, { label: "服务", value: 2 }])}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider orientation="left">需求信息</Divider>

                    <Form.Item label="需求名称">
                        {getFieldDecorator('name', {
                            initialValue: vo.name,
                            rules: [
                                {
                                    required: true,
                                    message: '请输入需求名称！',
                                },
                            ],
                        })(<Input maxLength={200} placeholder="请输入需求名称" />)}
                    </Form.Item>

                    <Row gutter={18}>
                        <Col span={12}>
                            <Form.Item label="需求类型">
                                {getFieldDecorator('type', {
                                    initialValue: vo["type"] || undefined
                                })(
                                    <Select placeholder="请选择需求类型">
                                        {createSelectOption([
                                            { label: "技术难点攻关", value: "1" },
                                            { label: "技术专家推荐", value: "2" },
                                            { label: "技术机构合作", value: "3" },
                                            { label: "企业产品推广", value: "4" },
                                            { label: "企业转型升级", value: "5" },
                                            { label: "企业融资上市", value: "6" },
                                        ])}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="领域" required>
                                <div className="p-sm-l">
                                    {scopes.map(({ label }, i) => <Tag className="white-tag" key={label} closable onClose={onCloseScope.later(i)}>{label}</Tag>)}
                                    <Button className="ant-tag--addBtn" onClick={scopeSelectModal.show.later({ selectScope: scopes, callback: onChangeOrgScope })} type="primary" >+</Button>
                                </div>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item label="需求简述">
                        <BraftEditor className="border bor-ra-xs" value={vo.profile} onChange={onChangeProfile} placeholder={`简明扼要介绍需求基本情况，包含需求内容及预期目标（至少200个字符，100个汉字）
期望技术（至少100个字符，50个汉字）`} />
                        {/* {getFieldDecorator('profile', {
                            initialValue: vo.profile,
                        })(<TextArea rows={5} placeholder="请输入需求简述" />)} */}
                    </Form.Item>
                    <Form.Item label="现有工作基础">
                        {getFieldDecorator('detail_desc', {
                            initialValue: vo.detail_desc,
                        })(<TextArea rows={4} placeholder="请输入现有工作基础" />)}
                    </Form.Item>
                    <Form.Item label="拟投资金额">
                        {getFieldDecorator('investment_amount', {
                            initialValue: vo.investment_amount,
                        })(<Input maxLength={50} placeholder="请输入拟投资金额" />)}
                    </Form.Item>
                    <Form.Item label="用途">
                        {getFieldDecorator('uses', {
                            initialValue: vo.uses,
                        })(<TextArea maxLength={500} placeholder="请输入用途" />)}
                    </Form.Item>
                    <Form.Item label="拟合作科研院所">
                        {getFieldDecorator('cooperative_institute', {
                            initialValue: vo.cooperative_institute,
                        })(<TextArea maxLength={500} placeholder="请输入拟合作科研院所" />)}
                    </Form.Item>
                    <Form.Item label="合作方式">
                        {getFieldDecorator('cooperation_mode', {
                            initialValue: vo["cooperation_mode"] || undefined
                        })(
                            <Select placeholder="请选择合作方式">
                                {createSelectOption([
                                    { label: "股权投资", value: 0 },
                                    { label: "技术转让", value: 1 },
                                    { label: "技术入股", value: 2 },
                                    { label: "合作开发", value: 3 },
                                    { label: "合作兴办企业", value: 4 },
                                    { label: "委托研发", value: 5 },
                                    { label: "委托团队、专家长期技术服务", value: 6 },
                                    { label: "共建新研发、生产实体", value: 7 },
                                    { label: "其他", value: 8 },
                                ])}
                            </Select>
                        )}
                    </Form.Item>
                    <Row gutter={18}>
                        <Col span={12}>
                            <Form.Item label="保密要求">
                                {getFieldDecorator('secrecy', {
                                    initialValue: vo["secrecy"]
                                })(
                                    <Select placeholder="请选择保密要求">
                                        {createSelectOption([
                                            { label: "无", value: 0 },
                                            { label: "有", value: 1 },
                                        ])}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="同意公开需求信息">
                                {getFieldDecorator('is_open', {
                                    initialValue: vo["is_open"]
                                })(
                                    <Select placeholder="请选择同意公开需求信息">
                                        {createSelectOption([
                                            { label: "是", value: 0 },
                                            { label: "否", value: 1 },
                                            { label: "部分公开", value: 3 },
                                        ])}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>


                    <Form.Item label="公开说明">
                        {getFieldDecorator('is_open_info', {
                            initialValue: vo.is_open_info,
                        })(<TextArea maxLength={500} placeholder="请输入公开说明" />)}
                    </Form.Item>
                    <Form.Item label="需求关键字">
                        {getFieldDecorator('keyword', {
                            initialValue: vo.keyword,
                        })(<Input maxLength={200} placeholder="请输入需求关键字" />)}
                    </Form.Item>

                    <Row gutter={18}>
                    </Row>
                    <Col span={12}>
                        <Form.Item label="发布文档">
                            {getFieldDecorator('docs', {
                                initialValue: vo["docs"],
                            })(
                                <Upload
                                    style={{ minWidth: "160px" }}
                                    name="files"
                                    onFinish={onUploadFileFinish.later("build_docs")}
                                    action={uploadUrl}
                                    defaultFileList={(files.build_docs || []).map(({ file_name, file_path }, i) => ({ name: file_name, url: `http://${UPLOAD_SERVER_HOST}${file_path}`, status: 'done', uid: i + 1 }))}
                                    onRemove={onRemoveFile.later("build_docs")}
                                >
                                    <Button><Icon type="upload" /> 上传</Button>
                                </Upload>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="背景材料、信息袋">
                            {getFieldDecorator('enclosure', {
                                initialValue: vo["enclosure"],
                            })(
                                <Upload
                                    style={{ minWidth: "160px" }}
                                    name="files"
                                    onFinish={onUploadFileFinish.later("enclosure")}
                                    action={uploadUrl}
                                    defaultFileList={(files.enclosure || []).map(({ file_name, file_path }, i) => ({ name: file_name, url: `http://${UPLOAD_SERVER_HOST}${file_path}`, status: 'done', uid: i + 1 }))}
                                    onRemove={onRemoveFile.later("enclosure")}
                                >
                                    <Button><Icon type="upload" /> 上传</Button>
                                </Upload>
                            )}
                        </Form.Item>
                    </Col>
                </div>

                <Form.Item {...tailFormItemLayout} className="m-sm-t">
                    <Button type="primary" htmlType="submit" loading={loading}>
                        保存
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
})

export default App;